import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

// Handles the return leg of Emergent Managed Google Auth.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const AuthCallback = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const match = window.location.hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;
    // Clear the fragment immediately: the session_id is single-use and must never linger in the URL
    window.history.replaceState(null, "", window.location.pathname + window.location.search);

    if (!sessionId) {
      navigate("/auth", { replace: true });
      return;
    }

    api.post("/auth/google/session", { session_id: sessionId })
      .then(({ data }) => {
        login(data.token, data.user);
        if (data.needs_role) {
          toast.success("Signed in with Google — choose your role to finish");
          navigate("/auth/role", { replace: true });
        } else {
          toast.success(`Welcome back, ${data.user.name}`);
          navigate("/dashboard", { replace: true });
        }
      })
      .catch((e) => {
        toast.error(errMsg(e, "Google sign-in failed. Please try again."));
        navigate("/auth", { replace: true });
      });
  }, [navigate, login]);

  return (
    <div data-testid="auth-callback-loading" className="flex min-h-screen flex-col items-center justify-center gap-3">
      <Loader2 className="h-6 w-6 animate-spin text-[hsl(174,38%,34%)]" />
      <p className="text-sm text-muted-foreground">Completing Google sign-in…</p>
    </div>
  );
};
